import React, { useState, useEffect } from "react";
import { Modal, Checkbox, Image, Upload, message } from "antd";
// import { observer } from "mobx-react-lite";
import { useEmployeeById, useEmployee } from "../../../app/hooks/useEmployee";
import moment from "moment";
import { useStore } from "../../../app/stores/store";
import PropTypes from "prop-types";

const EmployeeDetailsModal = ({ id, handleCancel, onSubmit }) => {
  EmployeeDetailsModal.propTypes = {
    id: PropTypes.string.isRequired,
    handleCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
  };

  const {
    data,
    employeePersonalProfile,
    currentEmployment,
    previousEmloyment,
  } = useEmployeeById(id);

  const { employeeStore } = useStore();

  const { fileList, setFileList } = employeeStore;

  const { patch } = useEmployee();

  const [profilePic, setProfilePic] = useState(data?.profileImagePath);

  useEffect(() => {
    if (data) {
      data?.profileImagePath
        ? setProfilePic(data?.profileImagePath)
        : setProfilePic("");
    }
  }, [data]);

  // upload logic

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!");
      return false;
    }

    const isSizeAccepted = file.size / 1024 / 1024 < 20; // 20MB
    if (!isSizeAccepted) {
      message.error("Image must be smaller than 20MB!");
      return false;
    }
    return true;
  };

  const handleChange = (info) => {
    let newFileList = [...info.fileList];

    // Limit the number of uploaded files
    newFileList = newFileList.slice(-1);

    // Update the state
    setFileList(newFileList);
  };

  // console.log(data.profileImagePath, " before ")
  const customRequest = async ({ file, onSuccess }) => {
    // Extract the file path from the file object
    setProfilePic(URL.createObjectURL(file));
    // Send the file path to your server or store it as needed
    try {
      const updateFormData = {
        id: data.id,
        EmployeePhoto: file,
      };

      await patch(updateFormData);
      onSubmit(); // mutate as props
    } catch (error) {
      console.log(error);
    }

    onSuccess();
    message.success(`${file.name} file uploaded successfully.`);
  };

  return (
    <Modal
      footer={null}
      style={{ top: 110 }}
      width={900}
      className="modalContainer"
      open={true}
      closable={true}
      maskClosable={true}
      onCancel={handleCancel}
    >
      <div className="employeeDetailsContainer">
        <div className="detailsContainer1">
          <div className="uploadContainer">
            <Upload
              className="uploadPhoto"
              customRequest={customRequest}
              beforeUpload={beforeUpload}
              onChange={handleChange}
              fileList={fileList}
              showUploadList={false} // hide default file list
            >
              <Image
                style={{ borderRadius: 150 }}
                preview={false}
                width={230}
                height={230}
                src={profilePic}
                fallback="data:image/png;base64,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"
              />
            </Upload>
          </div>

          <h2 style={{ textAlign: "center" }}>Active</h2>
          <div className="filesContainer">
            <h3>Files</h3>
            <p>file1.docx</p>
            <p>file2.docx</p>
            <p>file3.docx</p>
            <p>file4.docx</p>
            <p>View More</p>
          </div>
          <Checkbox>ELIGIBLE FOR LOAN</Checkbox>
        </div>

        <div className="detailsContainer2">
          <div className="personalInfo">
            <h2 className="detailHeader">
              Personal <span style={{ color: "orange" }}>Information</span>
            </h2>

            <div className="info">
              <p className="infoName">
                <b style={{ marginRight: 5 }}>Full Name:</b>
                {`${data?.firstName} ${data?.middleName} ${data?.lastName}`}
              </p>
              <p>
                <b style={{ marginRight: 5 }}>Contact #:</b>
                {data?.phoneNumber}
              </p>
            </div>
            <div className="info">
              <p className="infoName">
                <b style={{ marginRight: 5 }}>Birthdate:</b>{" "}
                {employeePersonalProfile?.birthDate}
              </p>
              <p>
                <b style={{ marginRight: 5 }}>Civil Status:</b>
                {employeePersonalProfile?.civilStatus}
              </p>
            </div>
            <div className="info">
              <p>
                <b style={{ marginRight: 5 }}>Address:</b>{" "}
                {employeePersonalProfile?.permanentddress}
              </p>
            </div>
            <div className="infoContainer">
              <div className="info">
                <p className="infoNum">
                  <b style={{ marginRight: 5 }}>SSS #:</b>{" "}
                  {employeePersonalProfile?.sssNumber}
                </p>
                <p>
                  <b style={{ marginRight: 5 }}>PHILHEALTH #:</b>
                  {employeePersonalProfile?.philhealthNumber}
                </p>
              </div>
              <div className="info">
                <p className="infoNum">
                  <b style={{ marginRight: 5 }}>PAGIBIG #:</b>
                  {employeePersonalProfile?.pagIbigNumber}
                </p>
                <p>
                  <b style={{ marginRight: 5 }}>TIN #:</b>{" "}
                  {employeePersonalProfile?.tinNumber}
                </p>
              </div>

              <h3 style={{ margin: 0, marginLeft: 10, marginTop: 10 }}>
                <span style={{ color: "orange" }}>In Case of</span> Emergency
              </h3>
              <div className="info">
                <p className="infoName">
                  <b style={{ marginRight: 5 }}>Contact Name:</b>
                  {employeePersonalProfile?.emergencyContactName}
                </p>
                <p>
                  <b style={{ marginRight: 5 }}>Contact #:</b>
                  {employeePersonalProfile?.emergencyContactNumber}
                </p>
              </div>
            </div>
          </div>
          <div className="employmentInfo">
            <h2 className="detailHeader">
              Employment <span style={{ color: "orange" }}>Information</span>
            </h2>
            <div className="info">
              <p className="infoName">
                <b style={{ marginRight: 5 }}>Position:</b>
                {currentEmployment?.positionName}
              </p>
              <p>
                <b style={{ marginRight: 5 }}>Date Hired:</b>
                {currentEmployment
                  ? moment(currentEmployment?.dateHired).format("YYYY/MM/DD")
                  : ""}
              </p>
            </div>
            <div className="info">
              <p className="infoName">
                <b style={{ marginRight: 5 }}>Employment Status:</b>
                {currentEmployment?.employmentStatus}
              </p>
              <p>
                <b style={{ marginRight: 5 }}>Employee #:</b>
                {data?.employeeNumber}
              </p>
            </div>
            

            <div className="info">
              <p className="infoName">
                <b style={{ marginRight: 5 }}>Work Assignment:</b>
                {currentEmployment?.regionName}
              </p>
              <p>
                <b style={{ marginRight: 1 }}>Employee Status:</b>
                {data?.employeeStatus}
              </p>
            </div>
            {/* <div className="info">
              <p>
                <b style={{ marginRight: 5 }}>Pre Employment Status:</b>
              </p>
            </div> */}
            <h2 className="detailHeader">
              Brief <span style={{ color: "orange" }}>Salary </span>
              Information
            </h2>
            <div className="info">
              <p className="infoNum1">
                <b style={{ marginRight: 5 }}>Basic Pay: </b>
                {currentEmployment?.employmentSalary?.basicPay}
              </p>
              <p className="infoNum1">
                <b style={{ marginRight: 5 }}>Provision Pay: </b>
                {currentEmployment?.employmentSalary?.addOnProvision}
              </p>
              <p>
                <b style={{ marginRight: 5 }}>Net of Tax: </b>
                {currentEmployment?.employmentSalary?.netOfTax ? "Yes" : "No"}
              </p>
            </div>
            <div className="info">
              <p className="infoNum1">
                <b style={{ marginRight: 5 }}>Previous Salary:</b>
                {previousEmloyment
                  ? previousEmloyment?.employmentSalary?.basicPay
                  : 0}
              </p>
              <p>
                <b style={{ marginRight: 5 }}>Allowance:</b>
              </p>
            </div>
            <div className="infoBtnContainer">
              <button className="employeeDetailsBtn">
                Generate 13th Month
              </button>
              <button className="employeeDetailsBtn">Add Additional Pay</button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default EmployeeDetailsModal;
